<script>
	let turnout;
	export {turnout as globTurnout}
	export let eligibleVoters;
	let ballotsCast
	export {ballotsCast as globBallotCast};
	let totalPolls
	export {totalPolls as globTabulators};
	let closedPolls;
	export {closedPolls as globClosedTabulators}
</script>

<dl>
	{#if eligibleVoters > 0}
		<dt>Eligible Voters</dt>
		<dd>{eligibleVoters}</dd>
	{/if}
	{#if ballotsCast >= 0}
		<dt>Ballots Cast</dt>
		<dd>{ballotsCast}</dd>
	{/if}
	{#if turnout}
		<dt>Turnout</dt>
		<dd>{turnout}</dd>
	{/if}
	<!-- each memory stick result is a 'reporting poll' (i.e. tabulator in the json export)-->
	{#if totalPolls > 0} 
		<dt>Polls Reporting</dt>
		<dd>{closedPolls>=0?closedPolls:0} of {totalPolls}</dd>
	{/if}
</dl>

<style>
	dl {
		display: flex;
		flex-flow: row wrap;
	}

	dt {
		flex-basis: 30%;
		text-align: left;
		padding-right:1em;
		min-width: 8em;
		max-width: 12em;
	}

	dt::after {
		content: ':';
	}

	dd {
		flex-basis: 70%;
		margin: 0;
		font-weight: 300;
	}
	
	dd,
	dt {
		line-height: 1.5em;
	}
</style>
